import React from 'react';
import segmentImage from '../data/segment_preference_index.png';

const SegmentPreferenceIndex = () => {
    return (
        <div>
            <h2>Population size and Preference Overview</h2>
            <p style={{ marginTop: '-16px', color: '#2c2c2c' }}>
                1 = Low Customer Interest. 5 = High Customer Interest.
            </p>
            <img
                src={segmentImage}
                alt="Segment Preference Index"
                style={{ width: '100%', height: 'auto', paddingBottom: '24px', marginTop:'-8px' }}
            />
        </div>
    );
};

export default SegmentPreferenceIndex;
